export const experimentSubjectCookieName = 'experimentSubject';
export const experimentAssignmentsCookieName = 'experimentAssignments';
export const experimentCookieMaxAgeSeconds = 60 * 60 * 24 * 365;
